'use strict';

// TODO allow this to accept a form type / FB, and do proper return
define('features/slp/set.campaign.code',[
  'detectizr',
  'lib/util/langFromUrl'
], function (
  detectizr,
  langFromUrl
) {
  // TODO: stop using 'Default' and 'short'?
  return function setCampaignCode(formType, formLength, usedFB) {
    var device = detectizr.device.type;
    var landing = window.location.pathname.indexOf('/landing/') >= 0;
    var shortForm = 1;
    var longForm = 2;
    var adjLongForm = 3;
    if (usedFB) {
      shortForm = 4;
      longForm = 5;
      adjLongForm = 7;
    }

    if (formType === 'contact-dealer') {
      if (device === 'desktop') {
        if (landing) {
          if (formLength === 'short') {
            return 'TWBT1720000' + shortForm;
          }
          return 'TWBT1720000' + adjLongForm;
        }
        if (formLength === 'short') {
          return 'TWBT1717000' + shortForm;
        }
        return 'TWBT1717000' + longForm;
      }

      if (device === 'tablet') {
        if (landing) {
          if (formLength === 'short') {
            return 'TWBT1722000' + shortForm;
          }
          return 'TWBT1722000' + longForm;
        }
        if (formLength === 'short') {
          return 'TWBT1719000' + shortForm;
        }
        return 'TWBT1719000' + longForm;
      }

      // default (mobile)
      if (landing) {
        if (formLength === 'short') {
          return 'TMBT1721000' + shortForm;
        }
        return 'TMBT1721000' + longForm;
      }

      if (formLength === 'short') {
        return 'TMBT1718000' + shortForm;
      }
      return 'TMBT1718000' + longForm;
    }

    // BAT-4668 - see spreadsheet attached to BAT25-450
    if (formType === 'request-a-quote') {
      var campaignCode = '';
      // If logged in using Facebook
      if (usedFB) {
        // console.log('Using Facebook');
        if (formLength === 'short') {
          // Spanish Short Form
          if (langFromUrl() === 'es') {
            switch (device) {
              case 'desktop':
                campaignCode = 'TWBT27320005'; // Spanish Short Form FB Desktop
                break;
              case 'tablet':
                campaignCode = 'TMBT27320004'; // Spanish Short Form FB Tablet
                break;
              case 'mobile':
                campaignCode = 'TMBT27320004'; // Spanish Short Form FB Mobile
                break;
              default:
                campaignCode = 'TWBT27320005'; // Spanish Short Form FB Default
            }
          }

          // English Short Form LANDING
          if (landing) {
            switch (device) {
              case 'desktop':
                campaignCode = 'TWBT17120004'; // English Short Form FB Desktop LANDING
                break;
              case 'tablet':
                campaignCode = 'TWBT17140004'; // English Short Form FB Tablet LANDING
                break;
              case 'mobile':
                campaignCode = 'TMBT17130004'; // English Short Form FB Mobile LANDING
                break;
              default:
                campaignCode = 'TWBT17120004'; // English Short Form FB Default Landing
            }
          } else {
            // English Short Form NON LANDING
            switch (device) {
              case 'desktop':
                campaignCode = 'TWBT17090004'; // English Short Form FB Desktop NON Landing
                break;
              case 'tablet':
                campaignCode = 'TWBT17110004'; // English Short Form FB Tablet NON Landing
                break;
              case 'mobile':
                campaignCode = 'TMBT17100004'; // English Short Form FB Mobile NON Landing
                break;
              default:
                campaignCode = 'TWBT17090004'; // English Short Form FB Default NON Landing
            }
          }
        } else if (langFromUrl() === 'es') {
          switch (device) {
            case 'desktop':
              campaignCode = 'TWBT27320005'; // Spanish Long Form FB Desktop
              break;
            case 'tablet':
              campaignCode = 'TWBT27320005'; // Spanish Long Form FB Tablet
              break;
            case 'mobile':
              campaignCode = 'TMBT27320005'; // Spanish Long Form FB Mobile
              break;
            default:
              campaignCode = 'TWBT27320005'; // Spanish Long Form FB Default
          }
        } else if (landing) {
          switch (device) {
            case 'desktop':
              campaignCode = 'TWBT17120005'; // English Long Form FB Desktop LANDING
              break;
            case 'tablet':
              campaignCode = 'TWBT17140005'; // English Long Form FB Tablet LANDING
              break;
            case 'mobile':
              campaignCode = 'TMBT17130005'; // English Long Form FB Mobile LANDING
              break;
            default:
              campaignCode = 'TWBT17120005'; // English Long Form FB Default LANDING
          }
        } else {
          // English Long Form NON LANDING
          switch (device) {
            case 'desktop':
              campaignCode = 'TWBT17090005'; // English Long Form FB Desktop NON Landing
              break;
            case 'tablet':
              campaignCode = 'TWBT17110005'; // English Long Form FB Tablet NON Landing
              break;
            case 'mobile':
              campaignCode = 'TMBT17100005'; // English Long Form FB Mobile NON Landing
              break;
            default:
              campaignCode = 'TWBT17090005'; // English Long Form FB Default NON Landing
          }
        }
      } else if (formLength === 'short') {
        // Spanish Short Form
        if (langFromUrl() === 'es') {
          switch (device) {
            case 'desktop':
              campaignCode = 'TWBT27320001'; // Spanish Short Form Non-FB Desktop
              break;
            case 'tablet':
              campaignCode = 'TMBT27320001'; // Spanish Short Form Non-FB Tablet
              break;
            case 'mobile':
              campaignCode = 'TMBT27320001'; // Spanish Short Form Non-FB Mobile
              break;
            default:
              campaignCode = 'TWBT27320001'; // Spanish Short Form Non-FB Default
          }
        } else if (landing) {
          switch (device) {
            case 'desktop':
              campaignCode = 'TWBT17120001'; // English Short Form Non-FB Desktop LANDING
              break;
            case 'tablet':
              campaignCode = 'TWBT17140001'; // English Short Form Non-FB Tablet LANDING
              break;
            case 'mobile':
              campaignCode = 'TMBT17130001'; // English Short Form Non-FB Mobile LANDING
              break;
            default:
              campaignCode = 'TWBT17120001'; // English Short Form Non-FB Default Landing
          }
        } else {
          // English Short Form NON LANDING
          switch (device) {
            case 'desktop':
              campaignCode = 'TWBT17090001'; // English Short Form Non-FB Desktop NON Landing
              break;
            case 'tablet':
              campaignCode = 'TWBT17110001'; // English Short Form Non-FB Tablet NON Landing
              break;
            case 'mobile':
              campaignCode = 'TMBT17100001'; // English Short Form Non-FB Mobile NON Landing
              break;
            default:
              campaignCode = 'TWBT17090001'; // English Short Form Non-FB Default NON Landing
          }
        }
      } else if (langFromUrl() === 'es') {
        switch (device) {
          case 'desktop':
            campaignCode = 'TWBT27320002'; // Spanish Long Form Non-FB Desktop
            break;
          case 'tablet':
            campaignCode = 'TMBT27320002'; // Spanish Long Form Non-FB Tablet
            break;
          case 'mobile':
            campaignCode = 'TMBT27320002'; // Spanish Long Form Non-FB Mobile
            break;
          default:
            campaignCode = 'TWBT27320002'; // Spanish Long Form Non-FB Default
        }
      // English Long Form LANDING
      } else if (landing) {
        switch (device) {
          case 'desktop':
            campaignCode = 'TWBT17120002'; // English Long Form Non-FB Desktop LANDING
            break;
          case 'tablet':
            campaignCode = 'TWBT17140002'; // English Long Form Non-FB Tablet LANDING
            break;
          case 'mobile':
            campaignCode = 'TMBT17130002'; // English Long Form Non-FB Mobile LANDING
            break;
          default:
            campaignCode = 'TWBT17120002'; // English Long Form Non-FB Default LANDING
        }
      // English Long Form NON LANDING
      } else {
        switch (device) {
          case 'desktop':
            campaignCode = 'TWBT17090002'; // English Long Form Non-FB Desktop NON Landing
            break;
          case 'tablet':
            campaignCode = 'TWBT17110002'; // English Long Form Non-FB Tablet NON Landing
            break;
          case 'mobile':
            campaignCode = 'TMBT17100002'; // English Long Form Non-FB Mobile NON Landing
            break;
          default:
            campaignCode = 'TWBT17090002'; // English Long Form Non-FB Default NON Landing
        }
      }
      return campaignCode;
    }

    if (formType === 'schedule-a-test-drive') {
      if (device === 'desktop') {
        if (landing) {
          if (formLength === 'short') {
            return 'TWBT1727000' + shortForm;
          }
          return 'TWBT1727000' + longForm;
        }
        if (formLength === 'short') {
          return 'TWBT1723000' + shortForm;
        }
        return 'TWBT1723000' + longForm;
      }

      if (device === 'tablet') {
        if (landing) {
          if (formLength === 'short') {
            return 'TWBT1729000' + shortForm;
          }
          return 'TWBT1729000' + longForm;
        }
        if (formLength === 'short') {
          return 'TWBT1726000' + shortForm;
        }
        return 'TWBT1726000' + longForm;
      }

      // default (mobile)
      if (landing) {
        if (formLength === 'short') {
          return 'TMBT1728000' + shortForm;
        }
        return 'TMBT1728000' + longForm;
      }
      if (formLength === 'short') {
        return 'TMBT1724000' + shortForm;
      }
      return 'TMBT1724000' + longForm;
    }

    return null;
  };
});

